/**
 * Convert lowercase string to First letter capital
 * @param value received value
 * @returns Capitalized string
 */
export const Capitalize = (value: string): string => {
  return (value && value.length > 0) ? value.charAt(0).toUpperCase() + value.slice(1) : "";
};

/**
 * Convert string to boolean
 * @param value received value
 * @returns boolean
 */
export const StringToBoolean = (value: string): boolean => {
  return value === "true";
};

/**
 * Convert lowercase string to First letter capital for ethnicity category
 * @param value received value
 * @returns Capitalized string
 */
export const CapitalizeEthnicityCategory = (value: string): string => {
  const caseConversion = (value && value.length > 0) ?
    value.charAt(0).toUpperCase() + value.slice(1).toLocaleLowerCase()
    : "";
  return caseConversion.replace(/_/g, " ");
};
